module.exports = __webpack_public_path__ + "img/fitness-xiaochengxucode.8c2c94be.png";